import { motion } from 'framer-motion';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

export function Layout() {
  const { user } = useAuthStore();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '100vh',
        background: 'var(--color-bg-primary)',
      }}
    >
      {/* Header */}
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 16px',
          paddingTop: 'max(12px, env(safe-area-inset-top))',
          background: 'var(--color-bg-secondary)',
          borderBottom: '1px solid var(--color-border)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '24px' }}>🎯</span>
          <span style={{ fontWeight: 700, fontSize: '18px' }}>Streak</span>
        </div>

        {user && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
            }}
          >
            {/* Streak */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '6px 12px',
                background: 'rgba(249, 115, 22, 0.2)',
                borderRadius: '999px',
              }}
            >
              <span>🔥</span>
              <span style={{ fontWeight: 700, color: '#F97316' }}>{user.streak}</span>
            </div>

            {/* Tokens */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '6px 12px',
                background: 'rgba(255, 215, 0, 0.2)',
                borderRadius: '999px',
              }}
            >
              <span>🪙</span>
              <span style={{ fontWeight: 700, color: '#FFD700' }}>
                {user.tokens.toLocaleString()}
              </span>
            </div>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main
        style={{
          flex: 1,
          overflow: 'auto',
          padding: '16px',
          paddingBottom: '100px', // Extra padding to ensure content isn't hidden behind bottom nav
        }}
      >
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          padding: '8px 0',
          paddingBottom: 'max(8px, env(safe-area-inset-bottom))',
          background: 'var(--color-bg-secondary)',
          borderTop: '1px solid var(--color-border)',
        }}
      >
        <NavItem to="/" icon="🏠" label="Home" />
        <NavItem to="/events" icon="⚡" label="Events" />
        <NavItem to="/leaderboard" icon="🏆" label="Rank" />
        <NavItem to="/shop" icon="🛒" label="Shop" />
        <NavItem to="/profile" icon="👤" label="Profile" />
      </nav>
    </div>
  );
}

function NavItem({ to, icon, label }: { to: string; icon: string; label: string }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4px',
        padding: '8px 16px',
        textDecoration: 'none',
        color: isActive ? 'var(--color-accent-blue)' : 'var(--color-text-secondary)',
        transition: 'color 0.2s',
      })}
    >
      {({ isActive }) => (
        <motion.div
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          whileTap={{ scale: 0.9 }}
        >
          <span style={{ fontSize: '24px', filter: isActive ? 'none' : 'grayscale(0.5)' }}>
            {icon}
          </span>
          <span style={{ fontSize: '11px', fontWeight: isActive ? 600 : 400 }}>{label}</span>
        </motion.div>
      )}
    </NavLink>
  );
}
